var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Dollars",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-dollars","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M108.6 143.2l-2.4-21.2c5.6.3 10.8 2.3 15 5.9.1.1.2.1.3.1h.1c.1 0 .3-.1.3-.2l4.4-6.8c.1-.2.1-.5-.1-.7-5.7-4.7-12.7-7.2-20.8-7.2h-.2l-1-9c0-.1-.1-.3-.2-.3-.1-.1-.2-.1-.3-.1h-.1l-6.2.7c-.3 0-.5.3-.4.6l1 8.9c-12.4 2.3-20.2 11.1-19 21.6 1.5 13.2 14 15.4 23.3 16.9l2.7 23.9c-9.2-.2-15.5-4.7-18.5-7.4-.1-.1-.2-.1-.3-.1h-.1c-.1 0-.3.1-.4.2l-4.3 7c-.1.2-.1.5.1.6 4.1 3.8 11.4 8.3 22.7 8.3h1.7l1 8.6c0 .3.2.4.5.4h.1l6.2-.7c.3 0 .5-.3.4-.6l-1-8.6c19.8-4 19.8-18.4 19.3-22.7-1.4-13.2-12.4-16.2-23.8-18.1zm-19.9-9.3c-.6-5.5 3.5-10 10.3-11.4l2.2 19.6c-7.5-1.4-11.9-3.2-12.5-8.2zm23.5 41.6l-2.4-21.9c7.4 1.4 12.4 3.6 13.1 9.5.5 4.7-2.1 10.3-10.7 12.4z"/>
  <path d="M248 43c-1.6-2-3.8-3.3-6.4-3.6L58.9 17.9c-5.2-.6-10 3.1-10.6 8.3l-6.4 54.4-33.4 3.7c-2.5.3-4.8 1.5-6.4 3.5-1.6 2-2.3 4.5-2 7l14.4 128.9c.5 4.9 4.7 8.5 9.5 8.5.4 0 .7 0 1.1-.1l182.8-20.4c2.5-.3 4.8-1.5 6.4-3.5 1.6-2 2.3-4.5 2-7l-2-17.7 10.2 1.2c.4 0 .8.1 1.1.1 2.1 0 4.2-.7 5.9-2.1 2-1.6 3.3-3.8 3.6-6.4L249.9 50c.3-2.5-.4-5-1.9-7zm-41.2 159.8L23.9 223.2c-.2 0-.3 0-.4-.1-.1-.1-.2-.2-.2-.3L9 93.8c0-.2.1-.3.1-.4.1-.1.2-.2.3-.2l182.8-20.4h.1c.2 0 .5.2.5.4l14.4 128.9c0 .4-.2.7-.4.7zm19.2-27.5c0 .2-.1.3-.2.3-.1.1-.2.1-.4.1l-12.3-1.5-11.4-102c-.6-5.2-5.3-9-10.5-8.4L51.1 79.5l6.2-52.3c0-.2.3-.4.5-.4h.1l182.7 21.6c.2 0 .3.1.3.2.1.1.1.2.1.4l-15 126.3z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/dollars.svg